import { IAccessoryCategoryData, Module } from '@/models/configurator/module';
import { axios } from '@/plugins/axios';
import { objectToFormData } from '@/utils/objectToFormData';

export class ModuleService {
  private endpoint = 'v1/configurator/setup/modules/';

  async fetchModules(): Promise<Module[]> {
    return axios.get<Module[]>(`${this.endpoint}`).then(({ data }) => data);
  }

  async fetchModule(id: number): Promise<Module> {
    return axios.get<Module>(`${this.endpoint}${id}/`).then(({ data }) => data);
  }

  async createModule(module: Module): Promise<Module> {
    const formData = objectToFormData(module);

    return axios
      .post<Module>(`${this.endpoint}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then(({ data }) => data);
  }

  async updateModule(module: Module): Promise<Module> {
    const formData = objectToFormData(module);
    return axios
      .patch<Module>(`${this.endpoint}${module.id}/`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then(({ data }) => data);
  }

  async updateModuleOrder(module: Module): Promise<Module> {
    return axios
      .put<Module>(`${this.endpoint}${module.id}/set_order/`, {
        order: module.order
      })
      .then(({ data }) => data);
  }

  async deleteModule(id: number): Promise<any> {
    return axios.delete(`${this.endpoint}${id}/`);
  }

  async cloneModule(target: number): Promise<any> {
    return axios
      .post<Module>(`${this.endpoint}clone/`, undefined, {
        params: { target },
        timeout: 5 * 60 * 1000
      })
      .then(({ data }) => data);
  }

  async fetchModuleAccessoryCategories(
    id: number
  ): Promise<IAccessoryCategoryData[]> {
    return axios
      .get<IAccessoryCategoryData[]>(`${this.endpoint}${id}/accessories/`, {
        params: { 'commercial-description': 'true' }
      })
      .then(({ data }) => data);
  }
}
